import React from 'react';
import businessMd from './content/business';

function renderLine(line, i) {
  if (line.startsWith('# ')) return <h1 key={i}>{line.substring(2)}</h1>;
  if (line.startsWith('## ')) return <h2 key={i}>{line.substring(3)}</h2>;
  if (line.startsWith('### ')) return <h3 key={i}>{line.substring(4)}</h3>;
  if (line.startsWith('```')) return <pre key={i} style={{ background: '#f6f8fa', padding: 8 }}>{line}</pre>;
  if (line.startsWith('- ')) return <li key={i}>{line.substring(2)}</li>;
  if (line.trim() === '') return <br key={i} />;
  return <p key={i}>{line}</p>;
}

export default function Viewer() {
  const md = businessMd;

  const lines = md.split(/\r?\n/);

  // Simple handling: group consecutive list items into <ul>
  const out = [];
  let buffer = [];
  lines.forEach((l, i) => {
    if (l.startsWith('- ')) {
      buffer.push(renderLine(l, i));
    } else {
      if (buffer.length) {
        out.push(<ul key={`ul-${i}`}>{buffer}</ul>);
        buffer = [];
      }
      out.push(renderLine(l, i));
    }
  });
  if (buffer.length) out.push(<ul key={`ul-end`}>{buffer}</ul>);

  return <div style={{ padding: 12 }}>{out}</div>;
}
